import FormDialog, {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';
import FormFile from 'cl-form/FormFile/FormFile';
import * as React from 'react';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {GENERAL_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';
import InlineButton from '../../InlineButton';

export type ImportAmazonCsvFormData = {file: File};
export default function ImportAmazonCsvDialog(props: SpecificFormDialogProps<ImportAmazonCsvFormData>) {
  return (
    <FormDialog<ImportAmazonCsvFormData>
      maxWidth="sm"
      fullWidth
      formName={GENERAL_ACTIONS_TYPES.IMPORT_AMAZON_CSV}
      title="Import Products From Amazon.com Using CSV"
      validate={null}
      fields={[
        {
          component: FormFile,
          name: 'file',
          label: 'pick a csv from your computer',
          instructionText: (
            <React.Fragment>
              Download a{' '}
              <InlineButton
                disableOpenInNewIcon
                target={null}
                href="https://misc.crazylister.com/file-examples/asin.csv"
              >
                sample CSV template
              </InlineButton>{' '}
              to see an example of the format required.
              <br />
              Or you can download your{' '}
              <InlineButton href="https://sellercentral.amazon.com/listing/reports">
                Amazon Inventory Report
              </InlineButton>
              .
            </React.Fragment>
          ),
          instructionPosition: 'after',
        },
      ]}
      actions={
        <GeneralActions
          types={[GENERAL_ACTIONS_TYPES.IMPORT_AMAZON_CSV]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          lastActionColor="primary"
        />
      }
      {...props}
    />
  );
}
